import { motion } from "framer-motion";
import { education } from "../data/education";

const Education = () => {
  if (!Array.isArray(education) || education.length === 0) return null;

  return (
    <div className="relative max-w-5xl mx-auto px-6">
      {/* timeline vertical line */}
      <div className="absolute left-6 sm:left-7 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#00e0b7]/25 to-transparent pointer-events-none" />

      <div className="flex flex-col gap-10 relative">
        {education.map((ed, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="relative flex gap-6"
          >
            {/* timeline glowing dot */}
            <div className="flex flex-col items-center pt-2 relative z-10">
              <span className="w-3 h-3 rounded-full bg-gradient-to-r from-[#00e0b7] to-[#4b5fff] shadow-[0_0_12px_rgba(0,224,183,0.6)]" />
              {i !== education.length - 1 && (
                <span className="w-px flex-1 bg-gradient-to-b from-[#00e0b7]/30 to-transparent" />
              )}
            </div>

            {/* education card */}
            <div className="flex-1 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-teal-400/40 hover:shadow-[0_0_20px_rgba(0,224,183,0.15)] transition-all duration-500 p-6 md:p-8">
              <h3 className="text-lg md:text-xl font-semibold text-white mb-1">
                {ed.degree}
              </h3>
              <p className="text-slate-300 font-medium">{ed.school}</p>
              {ed.notes && (
                <p className="text-sm text-slate-400 mt-2 leading-relaxed">
                  {ed.notes}
                </p>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Education;
